const whiteList = {
  a: ['target', 'href', 'title'],
  abbr: ['title'],
  address: [],
  area: ['shape', 'coords', 'href', 'alt'],
  article: [],
  aside: [],
  audio: ['autoplay', 'controls', 'loop', 'preload', 'src'],
  b: ['style', 'background-color'],
  bdi: ['dir'],
  bdo: ['dir'],
  big: [],
  blockquote: ['cite', 'style'],
  br: [],
  caption: [],
  center: [],
  cite: [],
  code: [],
  col: ['align', 'valign', 'span', 'width'],
  colgroup: ['align', 'valign', 'span', 'width'],
  dd: [],
  del: ['datetime'],
  details: ['open'],
  div: ['style', 'align', 'data-i', 'data-j', 'class'],
  dl: [],
  dt: [],
  em: [],
  font: ['color', 'size', 'face'],
  footer: [],
  h1: [],
  h2: [],
  h3: [],
  h4: [],
  h5: [],
  h6: [],
  header: [],
  hr: [],
  i: [],
  img: ['src', 'alt', 'title', 'width', 'height', 'class', 'data-original', 'data-src', 'data-data-src', 'style'],
  ins: ['datetime'],
  li: ['style'],
  mark: [],
  nav: [],
  ol: [],
  p: ['style'],
  pre: [],
  s: [],
  section: [],
  small: [],
  span: ['style', 'class'],
  sub: [],
  sup: [],
  strong: [],
  table: ['width', 'border', 'align', 'valign', 'class', 'style'],
  tbody: ['align', 'valign'],
  td: ['width', 'colspan', 'align', 'valign', 'style'],
  tfoot: ['align', 'valign'],
  th: ['width', 'colspan', 'align', 'valign'],
  thead: ['align', 'valign'],
  tr: ['rowspan', 'align', 'valign'],
  tt: [],
  u: [],
  ul: [],
  video: ['autoplay', 'controls', 'loop', 'preload', 'src', 'height', 'width','controlsList','muted','type','playsinline','webkit-playsinline'],
  figure: ['contenteditable', 'id', 'style'],
  figcaption:['contenteditable'],
  'pcurrency-gdroucep': [],

};
module.exports = whiteList;
